import React from 'react';
import Can from "../Can";
import PubLabPage from "./PubLabPage";

function PubLab(props) {
    var myHome;

    const isAdmin = props.apiAuthGroups && props.apiAuthGroups.includes('ADMIN');

    if (!props.apiAuthGroups) {
        myHome = (
            null
        )
    } else {
        myHome = (
            <Can
                role={props.apiAuthGroups}
                perform="labRequest-page:visit"
                yes={() => (
                    <PubLabPage
                        apiAuthResponse={props.apiAuthResponse}
                        apiAuthName={props.apiAuthName}
                        apiAuthSurname={props.apiAuthSurname}
                        apiAuthGroups={props.apiAuthGroups}
                        isAdmin={isAdmin}
                    />
                )}
                no={() => (null)}
            />
        )
    }


    return myHome;
}

export default PubLab;